export const changeFavicon = (faviconUrl: string): void => {
  if (!faviconUrl) return;

  document
    .querySelectorAll<HTMLLinkElement>(
      'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]',
    )
    .forEach((link) => {
      link.href = faviconUrl;
      if (faviconUrl.endsWith('.svg')) {
        link.type = 'image/svg+xml';
      } else if (faviconUrl.endsWith('.png')) {
        link.type = 'image/png';
      }
    });
};
